module.exports = __webpack_public_path__ + "img/375.937130d6.jpg";